<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-5 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-7 col-lg-6 col-md-8 px-5">
              <h1><font color="#fff">TRAINING-DRMIS : DATA COLLECTOR</font></h1>
              <p class="text-lead text-white">
                (Disaster Risk Management Information System)
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-2">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Sign in with valid credentials</small>
              </div>
              <form role="form" @submit.prevent="handleSignIn">
                <base-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-email-83"
                  placeholder="Email"
                  v-model="model.email"
                ></base-input>

                <base-input
                  alternative
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  id="password"
                  placeholder="Password"
                  v-model="model.password"
                ></base-input>

                <b-form-checkbox
                  type="checkbox"
                  class="mb-3"
                  @change="visibility()"
                ><p>Show/Hide Password</p></b-form-checkbox>

                <div class="text-center">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >Sign in</base-button
                  >
                </div>
                <!-- <div class="text-center">
                  <base-button
                    type="primary"
                    class="my-4"
                    @click="getAdminBoundaries()"
                    >Sync</base-button
                  >
                </div> -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { auth } from "@/api/auth";
import { user } from "@/api/user";
import { check } from "@/api/check";
import swal from "sweetalert2";
import copyHelper from "../../../sync/helpers/copy";
import { mapGetters, mapActions } from "vuex";
//import winston from "../../../sync/config/winston";
//import config from "../../../sync/config/app";
import Localbase from "localbase";
const db = new Localbase("db_dmis_desktop");

export default {
  data() {
    return {
      model: {
        email: "",
        password: ""
      },
      session: false
    };
  },
  computed: {
    ...mapGetters({
      getAdmin1s: "dims/getAdmin1s",
      getAdmin2s: "dims/getAdmin2s",
      getAdmin3s: "dims/getAdmin3s",
      getAdmin3gvhs: "dims/getAdmin3gvhs",
      getAdmin3gvhvillages: "dims/getAdmin3gvhvillages",
      getUser: "users/getUser"
    })
  },
  methods: {
    ...mapActions({
      setAdmin1s: "dims/Admin1s",
      setAdmin2s: "dims/Admin2s",
      setAdmin3s: "dims/Admin3s",
      setAdmin3gvhs: "dims/Admin3gvhs",
      admin3gvhvillages: "dims/Admin3gvhvillages",
      setUser: "users/setUser",
      setUserToken: "users/setUserToken",
      loadEmailList: "users/loadEmailList",
      getLogInUser: "users/getLogInUser"
    }),

    async getAdminBoundaries() {
      let admin1s = await copyHelper.admin1Boundaries();

      await this.setAdmin1s([...admin1s]);

      await this.getAdmin1s.forEach(element => {
        db.collection("admin_1").add(element, element._id);
      });

      let admin2s = await copyHelper.admin2Boundaries();

      await this.setAdmin2s([...admin2s]);

      await this.getAdmin2s.forEach(element => {
        db.collection("admin_2").add(element, element._id);
      });

      let admin3s = await copyHelper.admin3Boundaries();

      await this.setAdmin3s([...admin3s]);

      await this.getAdmin3s.forEach(element => {
        db.collection("admin_3").add(element, element._id);
      });

      let admin3gvhs = await copyHelper.admin3gvhsBoundaries();

      await this.setAdmin3gvhs([...admin3gvhs]);

      await this.getAdmin3gvhs.forEach(element => {
        db.collection("admin_3gvhs").add(element, element._id);
      });

      let admin3gvhvillages = await copyHelper.admin3gvhvillagesBoundaries();

      await this.admin3gvhvillages([...admin3gvhvillages]);

      await this.getAdmin3gvhvillages.forEach(element => {
        db.collection("admin_3gvhvillages").add(element, element._id);
      });
    },

    visibility() {
      const passwordField = document.querySelector("#password");
      if (passwordField.getAttribute("type") === "password")
        passwordField.setAttribute("type", "text");
      else {
        passwordField.setAttribute("type", "password");
      }
    },
    handleSignIn() {
      if (this.model.email !== null && this.model.email !== null) {
        var response = auth.login(this.model);
        response.then(
          response => {
            var account = {
              id: response.userId,
              firstName: response.user.firstName,
              lastName: response.user.lastName,
              email: response.user.email,
              phone: response.user.phone,
              role: response.Role,
              district: response.Account.district,
              forms: response.Account.forms
            };
            console.log("response ", response);
            this.$session.set("user", account);
            this.$session.set("district", account.district);
            //Create User
            // console.log("user", account);
            this.setUser(account);
            this.setUserToken(response.id);
            if (response.Role.name === "officer") {
              swal({
                title: "",
                text: "Signed In Succesfully .",
                type: "success",
                toast: true,
                timer: 2500,
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
                position: "top-end"
              });
              this.loadEmailList();
              setTimeout(() => {
                this.$router.push({ path: "/setup", params: {} });
              }, 1000);
            } else {
              swal({
                text:
                  "Failed To Sign In ( invalid account only Officer Account Allowed )",
                type: "error",
                toast: true,
                position: "top-end",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              });
            }
          },
          reason => {
            swal({
              text:
                "Failed To Sign In ( possible invalid email and / or password : " +
                reason +
                " )",
              type: "error",
              toast: true,
              position: "top-end",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          }
        );
      } else {
        swal({
          text:
            "Failed To Sign In ( possible invalid email and / or password )",
          type: "error",
          toast: true,
          position: "top-end",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
      }
    }
  },
  async mounted() {
    if (typeof this.$route.query.session !== "undefined") {
      swal({
        text:
          "Sorry you dont have an active session. Please signin to access system",
        type: "error",
        toast: true,
        position: "top-end",
        confirmButtonClass: "btn btn-success btn-fill",
        buttonsStyling: false
      });
    }
  },
  async beforeMount() {
    var user = await this.getLogInUser();
    if (user) {
      this.$session.set("user", user);
      this.$session.set("district", user.district);
      this.$router.push({ path: "/setup", params: {} });
    }
  }
};
</script>
